import { render } from "./Tinymce.vue?vue&type=template&id=36b5f82f"
import script from "./Tinymce.vue?vue&type=script&lang=js"
export * from "./Tinymce.vue?vue&type=script&lang=js"
script.render = render

export default script